import encryptServer from '../request/encryptRequest';

// 发货列表(分页)
export const queryPage = (data = {}) => {
  return encryptServer.post('/xiaozi-xms/wireless/saas/sale/delivery/pageList', data);
};

// 发货统计
export const queryStateInfo = (data = {}) => {
  return encryptServer.post('/xiaozi-xms/wireless/saas/sale/delivery/count', data);
};

// 取消发货
export const cancel = (data = {}) => {
  return encryptServer.post('/xiaozi-xms/wireless/saas/notice/cancel', data);
};

// 发货详情
export const details = (data = {}) => {
  return encryptServer.post('/xiaozi-xms/wireless/saas/notice/details', data);
};

// 增量拉取小紫ERP发货单
export const pullXzErpDelivery = (data = {}) => {
  return encryptServer.post('/xiaozi-xms/wireless/saas/sale/delivery/pullXzErpDelivery', data, { timeout: 1000 * 60 * 5 });
};

// 取消发货
export const cancelDelivery = (data = {}) => {
  return encryptServer.post('/xiaozi-xms/wireless/saas/sale/delivery/cancel', data);
};

// 发货单详情(新)
export const deliveryDetail = (data = {}) => {
  return encryptServer.post('/xiaozi-xms/wireless/saas/sale/delivery/detail', data);
};

// 更新随货同行单
export const updateAccompanyBill = (data = {}) => {
  return encryptServer.post('/xiaozi-xms/wireless/saas/sale/delivery/updateAccompanyBill', data);
};
